import { createSlice } from "@reduxjs/toolkit";

const enterDateSlice = createSlice({
  name: "enterDateSlice",
  initialState: {
    userId: null,
    isStartDate: true,
  },
  reducers: {
    enterDateButton(state, action) {
      state.userId = action.payload.userId;
      state.isStartDate = action.payload.isStartDate;
    },
  },
});

export const { enterDateButton } = enterDateSlice.actions;
export const enterDateReducer = enterDateSlice.reducer;
